import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class CauseApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Causes`;
  }

  constructor(private http: HttpClient) {}

  loadCauses(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IdName[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IdName[]>>(this.url, { params });
  }

  loadAllCauses(): Observable<IdName[]> {
    const url = `${this.url}/All`;
    return this.http.get<IdName[]>(url);
  }

  loadCauseById(id: string): Observable<IdName> {
    const url = `${this.url}/${id}`;
    return this.http.get<IdName>(url);
  }

  createCause(cause: IdName): Observable<IdName> {
    return this.http.post<IdName>(this.url, cause, { headers });
  }

  updateCause(cause: IdName): Observable<IdName> {
    const url = `${this.url}/${cause.id}`;
    return this.http.put<IdName>(url, cause, { headers });
  }

  deleteCause(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
